module.exports = __webpack_public_path__ + "2df7e4c885303ff1ef23b45e0d7874d4.jpg";